import { useEffect, useState } from 'react';
import { api } from '@shared/api/client';
import { mergeDefaults } from '@admin/_shared';
import { DEFAULT_PLAN_BUILDER_CONFIG, type PlanBuilderConfig } from './config';

export function usePlanBuilderConfig(): { config: PlanBuilderConfig; loading: boolean } {
  const [config, setConfig] = useState<PlanBuilderConfig>(DEFAULT_PLAN_BUILDER_CONFIG);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    api
      .getPublishedConfig<PlanBuilderConfig>('plan_builder')
      .then((res) => {
        if (cancelled) return;
        if (res.snapshot?.config) {
          setConfig(mergeDefaults(DEFAULT_PLAN_BUILDER_CONFIG, res.snapshot.config));
        }
      })
      .catch(() => { /* defaults stand */ })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => { cancelled = true; };
  }, []);

  return { config, loading };
}
